import { Button, Card, Col, Input, Popconfirm, Row, Space } from 'antd';
import { Edit2, LayoutTemplate, Plus, Search, Trash2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TemplateModal from '../../components/TemplateModal';
import useAuth from '../../hooks/useAuth';
import { deleteTemplate, getTemplates } from '../../redux/actions/template';
import { getFormattedName } from '../../utils';

const TemplatesScreen = () => {
    const { user } = useAuth();
    const { templates } = useSelector((state) => state.templateSlice);
    const [searchText, setSearchText] = useState('');
    const [open, setOpen] = useState(false);
    const [templateData, setTemplateData] = useState(null);

    useEffect(() => {
        getTemplates();
    }, []);

    const filteredTemplates = templates.filter((template) =>
        getFormattedName(template?.name)?.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <div className="Templates">
            <div className="header-flex">
                <div className="page-title">Templates</div>
                {user?.role === 0 && (
                    <Space>
                        <Button
                            variant="solid"
                            color="primary"
                            size="large"
                            icon={<Plus />}
                            onClick={() => setOpen(true)}
                        >
                            Add Template
                        </Button>
                    </Space>
                )}
            </div>

            <div className="theme-bg shadow">
                <div className="filter-header p-6">
                    <Input
                        placeholder="Search..."
                        size="large"
                        allowClear
                        prefix={<Search size={18} color="rgb(156,163,175)" />}
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                    />
                </div>

                <Row gutter={[16, 16]} className="p-6">
                    {filteredTemplates?.map((template) => (
                        <Col key={template?.id} xs={24} sm={12} md={12} lg={6}>
                            <Card className="template-card shadow">
                                <div className="card-header">
                                    <h3 className="card-title">
                                        {getFormattedName(template?.name)}
                                    </h3>
                                    {user?.role === 0 && (
                                        <div className="actions">
                                            <Edit2
                                                size={16}
                                                color="rgb(107 114 128)"
                                                cursor="pointer"
                                                onClick={() => {
                                                    setOpen(true);
                                                    setTemplateData(template);
                                                }}
                                            />
                                            <Popconfirm
                                                title="Are you sure you want to delete this template?"
                                                okText="Yes"
                                                cancelText="No"
                                                onConfirm={() => deleteTemplate(template?.id)}
                                            >
                                                <Trash2 size={16} color="rgb(107 114 128)" cursor="pointer" />
                                            </Popconfirm>
                                        </div>
                                    )}
                                </div>
                                <p className="card-content mb-4">{template.content}</p>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>

            {open && (
                <TemplateModal
                    open={open}
                    onCancel={() => {
                        setOpen(false);
                        setTemplateData(null);
                    }}
                    data={templateData}
                />
            )}
        </div>
    );
};

export default TemplatesScreen;
